const actions = [
    {
        routeName: 'websites.show',
        items: [
            {
                title: 'Website Settings',
                routeName: 'websites.settings',
                params: { id: '{id}' },
            },
        ],
    },
    {
        routeName: 'websites.settings',
        items: [
            {
                title: 'Manage Website',
                routeName: 'websites.show',
                params: { id: '{id}' },
                hideOnSettings: true,
            },
            {
                title: 'Alerts',
                routeName: 'websites.alerts',
                params: { id: '{id}' },
                hideOnFab: true,
            },
            {
                title: 'Amenities',
                routeName: 'websites.amenities',
                params: { id: '{id}' },
                hideOnFab: true,
            },
            {
                title: 'Contacts',
                routeName: 'contacts.index',
                params: { id: '{id}' },
                hideOnFab: true,
            },
            {
                title: 'Contact Information',
                routeName: 'websites.contact-information',
                params: { id: '{id}' },
                hideOnFab: true,
            },
            {
                title: 'Deploy Changes',
                routeName: 'deploys.create',
                params: { id: '{id}' },
                hideOnFab: true,
            },
            {
                title: 'Deployments',
                routeName: 'deploys.index',
                params: { id: '{id}' },
                hideOnFab: true,
            },
            {
                title: 'Domains',
                routeName: 'websites.domains',
                params: { id: '{id}' },
                hideOnFab: true,
            },
            {
                title: 'Embed Codes',
                routeName: 'websites.embed-codes',
                params: { id: '{id}' },
                hideOnFab: true,
            },
            {
                title: 'External Links',
                routeName: 'websites.external-links',
                params: { id: '{id}' },
                hideOnFab: true,
            },
            {
                title: 'Floor Plans',
                routeName: 'websites.floorplans',
                params: { id: '{id}' },
                hideOnFab: true,
            },
            {
                title: 'Navigation Settings',
                routeName: 'websites.navigation-settings',
                params: { id: '{id}' },
                hideOnFab: true,
            },
            {
                title: 'Points Of Interest',
                routeName: 'websites.points-of-interest',
                params: { id: '{id}' },
                hideOnFab: true,
            },
            {
                title: 'Site Template',
                routeName: 'websites.site-templates',
                params: { id: '{id}' },
                hideOnFab: true,
            },
            {
                title: 'Log History',
                routeName: 'websites.log-history',
                params: { id: '{id}' },
                hideOnFab: true,
            },
        ],
    },
    {
        routeName: 'websites.floorplans',
        items: [
            {
                title: 'Add floor plan',
                routeName: 'websites.floorplans.create',
                params: { id: '{id}' },
            },
            {
                title: 'Import Availability',
                routeName: 'websites.floorplans.import',
                params: { id: '{id}' },
            },
        ],
    },
    {
        routeName: 'websites.floorplans.show',
        items: [
            {
                title: 'Delete floor plan',
                routeName: 'websites.floorplans.destroy',
                params: { id: '{id}' },
            },
        ],
    },
    {
        routeName: 'websites.points-of-interest',
        items: [
            {
                title: 'Manage Categories',
                routeName: 'websites.points-of-interest.categories',
                params: { id: '{id}' },
            },
        ],
    },
];

export default actions;
